import { inject, bindable, customElement } from 'aurelia';

declare const grecaptcha: any;

declare global {
    // tslint:disable-next-line:interface-name
    interface Window {
        grecaptcha: any;
        reCaptchaLoad: () => void;
    }
}

@customElement({ name: 'recaptcha', template: null })
@inject(Element)
export class Recaptcha {
    @bindable public verified: boolean;
    @bindable public theme: string = 'light';
    private _sitekey: string = '6Lf6lC0UAAAAAMooAPdFJUx9v5uCAwmSud-rlfNI';
    private _element: HTMLElement;
    constructor(element: HTMLElement) {
        this._element = element;
    }

    public attached(): void {
        if (this._isLocalhost()) {
            this.verified = true;
            return;
        }
        this._registerReCaptchaCallback();
        this._addScript();
    }

    private _isLocalhost(): boolean {
        const host = window.location.hostname;
        return host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
    }

    private _addScript(): void {
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?onload=reCaptchaLoad&render=explicit';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    }

    private _registerReCaptchaCallback(): void {
        window.reCaptchaLoad = () => {
            const config = {
                'sitekey': this._sitekey,
                'callback': this._onSuccess.bind(this),
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'expired-callback': this._onExpired.bind(this)
            };
            this._render(this._element, config);
        };
    }

    private _onExpired(): void {
        this.verified = false;
    }

    private _onSuccess(_token: string): void {
        this.verified = true;
    }

    private _render(element: HTMLElement, config: any): number {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        return grecaptcha.render(element, config);
    }
}
